import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance } from 'intact-vue';
import tinycolor from 'tinycolor2';
import { useState, watchState } from '../../hooks/useState';
import { throttle } from '../utils';
export function useValue() {
  var instance = useInstance();
  var hsv = useState(null);
  var hsl = useState(null);
  var format = useState(null);
  var rgb = useState(null);
  var hex = useState(null);
  instance.on('$receive:value', function (v) {
    var color = tinycolor(instance.get('value'));
    format.set(color.getFormat());
    hsv.set(color.toHsv());
  });
  watchState(hsv, function (hsv) {
    var color = tinycolor(hsv);
    rgb.set(color.toRgb());
    hex.set(color.toHex());
    hsl.set(color.toHsl());
    // if alpha less than 1, use rgba format
    var _format = hsv.a < 1 ? 'rgb' : format.value;
    instance.set('value', color.toString(_format));
  });
  function changeHue(v) {
    hsv.set(_extends({}, hsv.value, {
      h: v
    }));
  }
  function changeAlpha(v) {
    format.set('rgb');
    hsv.set(_extends({}, hsv.value, {
      a: v
    }));
  }
  function setValue(v) {
    hsv.set(tinycolor(v).toHsv());
  }
  return {
    format: format,
    hex: hex,
    rgb: rgb,
    hsv: hsv,
    hsl: hsl,
    changeHue: throttle(changeHue, 50),
    changeAlpha: throttle(changeAlpha, 50),
    setValue: setValue
  };
}